/**
 * Файл генерируется автоматически командой `npm run generate:advanced-filter`.
 * Не стоит его изменять руками, если вы не уверены в том, что делаете :)
 */
import { apartments } from './apartments';
import { balcony } from './balcony';
import { bathType } from './bathType';
import { bedrooms } from './bedrooms';
import { bedroomsNew } from './bedroomsNew';
import { ceilingHeight } from './ceilingHeight';
import { completionYear } from './completionYear';
import { constructionType } from './constructionType';
import { constructionYear } from './constructionYear';
import { contact } from './contact';
import { containWords } from './containWords';
import { dealType } from './dealType';
import { decorationsList } from './decorationsList';
import { demolition } from './demolition';
import { electronicTrading } from './electronicTrading';
import { elevators } from './elevators';
import { excludeWords } from './excludeWords';
import { facilities } from './facilities';
import { finishing } from './finishing';
import { flatRooms } from './flatRooms';
import { flatShare } from './flatShare';
import { floor } from './floor';
import { floors } from './floors';
import { fromMKAD } from './fromMKAD';
import { furniture } from './furniture';
import { garageStatus } from './garageStatus';
import { garageType } from './garageType';
import { garageUtilities } from './garageUtilities';
import { heatingType } from './heatingType';
import { isEncumbranceRealty } from './isEncumbranceRealty';
import { kitchenStove } from './kitchenStove';
import { landStatus } from './landStatus';
import { layout } from './layout';
import { livingConditions } from './livingConditions';
import { offerId } from './offerId';
import { offerSeller } from './offerSeller';
import { offerType } from './offerType';
import { onlineBooking } from './onlineBooking';
import { parking } from './parking';
import { possessor } from './possessor';
import { publicationDate } from './publicationDate';
import { rentTerms } from './rentTerms';
import { rentalPeriod } from './rentalPeriod';
import { repair } from './repair';
import { roomsInDeal } from './roomsInDeal';
import { saleType } from './saleType';
import { specialOffers } from './specialOffers';
import { squareMeterArea } from './squareMeterArea';
import { suburbanArea } from './suburbanArea';
import { suburbanAreaDailyrent } from './suburbanAreaDailyrent';
import { suburbanBathroom } from './suburbanBathroom';
import { suburbanFacilities } from './suburbanFacilities';
import { suburbanFloors } from './suburbanFloors';
import { suburbanHouseType } from './suburbanHouseType';
import { suburbanUtilities } from './suburbanUtilities';
import { undergroundTime } from './undergroundTime';
import { undergroundTimeNew } from './undergroundTimeNew';
import { urbanBathroom } from './urbanBathroom';
import { windows } from './windows';
import { withNeighbors } from './withNeighbors';
import { IFilter, TFilter } from '../../types/advancedFilters';
/* marker: prepend import */

export const ADVANCED_FILTERS: { [key in TFilter]: IFilter } = {
  apartments,
  electronicTrading,
  flatShare,
  balcony,
  bathType,
  ceilingHeight,
  completionYear,
  constructionType,
  constructionYear,
  contact,
  containWords,
  dealType,
  demolition,
  elevators,
  excludeWords,
  facilities,
  finishing,
  flatRooms,
  floor,
  floors,
  fromMKAD,
  garageType,
  garageStatus,
  garageUtilities,
  heatingType,
  isEncumbranceRealty,
  kitchenStove,
  landStatus,
  layout,
  livingConditions,
  offerId,
  offerType,
  onlineBooking,
  parking,
  publicationDate,
  rentTerms,
  rentalPeriod,
  repair,
  roomsInDeal,
  saleType,
  specialOffers,
  squareMeterArea,
  suburbanArea,
  suburbanAreaDailyrent,
  suburbanBathroom,
  suburbanFacilities,
  suburbanHouseType,
  suburbanUtilities,
  undergroundTime,
  urbanBathroom,
  windows,
  withNeighbors,
  bedrooms,
  decorationsList,
  possessor,
  bedroomsNew,
  suburbanFloors,
  offerSeller,
  undergroundTimeNew,
  furniture,
  /* marker: prepend key */
};
